/**
 * Legacy StorageService module — preserved as an empty AngularJS module so
 * existing dependencies (`acme.common.service.storage`) keep resolving.
 *
 * The actual `StorageService` factory is now registered in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts as a downgrade
 * of the Angular 18 StorageService at
 * apps/b2b-frontend/app/core/storage/storage.service.ts.
 *
 * Do NOT register `.service('StorageService', ...)` here — it would shadow
 * the downgraded service and reintroduce the legacy implementation.
 */
angular.module('acme.common.service.storage', []);
